/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Search_EndpointsInputs */

const en_search_endpoints = /** @type {(inputs: Search_EndpointsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Endpoints`)
};

const zh_hans1_search_endpoints = /** @type {(inputs: Search_EndpointsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`接口`)
};

const pt_br2_search_endpoints = /** @type {(inputs: Search_EndpointsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Endpoints`)
};

const es_search_endpoints = /** @type {(inputs: Search_EndpointsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Endpoints`)
};

const fr_search_endpoints = /** @type {(inputs: Search_EndpointsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Endpoints`)
};

const de_search_endpoints = /** @type {(inputs: Search_EndpointsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Endpoints`)
};

const ru_search_endpoints = /** @type {(inputs: Search_EndpointsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Эндпоинты`)
};

const it_search_endpoints = /** @type {(inputs: Search_EndpointsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Endpoint`)
};

/**
* | output |
* | --- |
* | "Endpoints" |
*
* @param {Search_EndpointsInputs} inputs
* @param {{ locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }} options
* @returns {LocalizedString}
*/
export const search_endpoints = /** @type {((inputs?: Search_EndpointsInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Search_EndpointsInputs, { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh-Hans") return zh_hans1_search_endpoints(inputs)
	if (locale === "pt-BR") return pt_br2_search_endpoints(inputs)
	if (locale === "es") return es_search_endpoints(inputs)
	if (locale === "fr") return fr_search_endpoints(inputs)
	if (locale === "de") return de_search_endpoints(inputs)
	if (locale === "ru") return ru_search_endpoints(inputs)
	if (locale === "it") return it_search_endpoints(inputs)
	return en_search_endpoints(inputs)
});